var UpdateSourceUpdateResponse = require('services/topic-update/update-source-update-response');
var EnumSerialiser = require('serialisers/enum-converter');
var Codec = require('io/codec');

var ResponseCodes = {
    SUCCESS : 0,
    INCOMPATIBLE_UPDATE : 1,
    UPDATE_FAILED : 2,
    INVALID_UPDATER : 3,
    MISSING_TOPIC : 4,
    INVALID_ADDRESS : 5,
    DUPLICATES : 6,
    EXCLUSIVE_UPDATER_CONFLICT : 7
};

module.exports = {
    read : function(input) {
        if (Codec.readByte(input) === 0) {
            return new UpdateSourceUpdateResponse();
        }

        var error = EnumSerialiser.read(input, ResponseCodes);

        return new UpdateSourceUpdateResponse(error);
    },
    write : function(output, req) {
        if (req.error) {
            Codec.writeByte(output, 1);
            EnumSerialiser.write(output, req.error, ResponseCodes);
        } else {
            Codec.writeByte(output, 0);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-update-response-serialiser.js
// module id = 1055
// module chunks = 1